import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Grid2,  } from '@mui/material';
import { Page } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {
	},
	content: {
		width: theme.breakpoints.values.md,
		maxWidth: '100%',
		margin: '0 auto',
		padding: '80px 24px',
		[theme.breakpoints.up('md')]: {
			padding: '160px 24px',
		},
	},
}));

const Home = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Home">
			<div className={classes.content}>
				<Grid2
					alignItems="center"
					className={classes.statsInner}
					container
					justifyContent="center"
					spacing={3}
				>
					<Grid2 item size={12}>
						<Typography align="center" gutterBottom variant="h1">
							Customer focus
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							We only find success in our customer’s success.
						</Typography>
					</Grid2>
					<Grid2 item size={12}>
						<Typography align="center" gutterBottom variant="h1">
							Excellence
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							Our clients know that we pursue nothing less than the highest quality standards in everything we do.
						</Typography>
					</Grid2>
					<Grid2 item size={12}>
						<Typography align="center" gutterBottom variant="h1">
							Collaboration
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							Our passion for teamwork leads to innovation, high level of effectiveness and continuous learning and improvement.
						</Typography>
					</Grid2>
					<Grid2 item size={12}>
						<Typography align="center" gutterBottom variant="h1">
							Accountability
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							People who are not afraid to get their ideas off the ground are also proud to be held accountable for their results.
						</Typography>
					</Grid2>
					<Grid2 item size={12}>
						<Typography align="center" gutterBottom variant="h1">
							Passion
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							Our passion is what keeps us relentlessly pushing for numerous game-changing innovations.
						</Typography>
					</Grid2>
				</Grid2>
			</div>
		</Page>
	);
};

export default Home;
